module.exports = __webpack_public_path__ + "img/auth-illustration.9d0053c7.png";